import React from 'react';
import { InputAdornment } from '@mui/material';

interface CustomInputAdornmentProps {
    unit?: string;
    suffix?: string;
}

export const CustomInputAdornment: React.FC<CustomInputAdornmentProps> = ({ unit, suffix }) => {
    const label = unit || suffix;

    if (!label) return null;

    return (
        <InputAdornment position="end">
            <span className="flex h-[4rem] min-w-[4rem] items-center justify-center rounded-full bg-input px-[0.75rem] text-small font-bold text-neutral-gray">
                {label}
            </span>
        </InputAdornment>
    );
};
